export const SCROLL_TOLERANCE = 0.3
